<template>
  <div class="estimate">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- 見積書の説明文 -->
    <div class="data-area" v-if="!isOpenPreview">
      <ul>
        <li class="text-title">見積書出力方法</li>
        <li>「見積書」左のチェックボックスをご選択いただき「チェックしたドキュメントの送信」をクリックください。<br>
          自動生成された見積書が添付されたメールが、登録メールアドレス宛に送られます。<br>
          設計原価で作成した見積書と、木取りした場合の見積書の2パターンをご確認いただけます。
        </li>
      </ul>
    </div>
    <!-- プレビュー -->
    <div id="tabBox" v-else>
      <div id="tabs">
        <div>
          <input type="radio" value="1" id="tab1" v-model="isActive"/>
          <label for="tab1">見積作成画面</label>
        </div>
        <div v-if="!isOrder">
          <input type="radio" value="2" id="tab2" v-model="isActive"/>
          <label for="tab2">価格フロー</label>
        </div>
      </div>
      <ul v-if="!isOrder" id="contents">
        <li v-if="isActive === '1'">
          <setting-value
            :estimate="estimate"
            @changeEstimateValue="changeEstimateValue"
          />
        </li>
        <li v-else-if="isActive === '2'">
          <price-flow
            :estimate="estimate"
            @changeEstimateValue="changeEstimateValue"
          />
        </li>
      </ul>
      <ul v-else id="order_contents">
        <li v-if="isActive === '1'">
          <setting-value
            :estimate="estimate"
            @changeEstimateValue="changeEstimateValue"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../constants/App'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import LoadingModal from '../../components/common/LoadingModal'
import SettingValue from './SettingValue'
import PriceFlow from './PriceFlow'
import EstimateSpecification from './EstimateSpecification'
export default {
  name: 'EstimatePreview',
  components: {
    'dd-loading-modal': LoadingModal,
    'setting-value': SettingValue,
    'price-flow': PriceFlow,
    'estimate-specification': EstimateSpecification
  },
  data () {
    return {
      // プレビューを閉じて説明文を開きたい場合はfalseにする
      isOpenPreview: true,
      estimate: {
        version: null,
        createdAt: null,
        sketchId: null,
        planId: null,
        companyName: null,
        parsonName: null,
        clientName: null,
        clientDepartment: null,
        clientParsonName: null,
        deliveryName: null,
        propertyName: null,
        deliveryAddr: null,
        deliveryDate: null,
        paymentConditions: null,
        materialCost: null,
        materialMagProb: null,
        processCost: null,
        productMagCost: null,
        factoryProfit: null,
        facttransCost: null,
        profitRate1: null,
        profitRate2: null,
        profitRate3: null,
        profitRate4: null,
        deliveryCost: null,
        executionCost: null,
        processCostOrigin: null,
        processTime: null,
        constructionCost: null,
        name: null,
        address: null,
        remarks1: null,
        remarks2: null,
        remarks3: null,
        remarks4: null,
        expirationDays: null
      },
      isActive: '1'
    }
  },
  props: {
    orderCode: String,
    spaceJoincd: String
  },
  methods: {
    /** 見積書プレビューの値を取得 */
    getEstimate: function () {
      let urlStr = ''
      let payload
      if (this.orderCode == null) {
        let eststr = '/estimate'
        if (this.isOrder) {
          eststr = '/estimate_order'
        }
        urlStr = API_URL.PREVIEW + eststr
        payload = {
          spaceJoincd: this.spaceJoincd
        }
      } else {
        urlStr = API_URL.ORDER + '/detail/estimate/preview'
        payload = {
          orderCode: this.orderCode,
          spaceJoincd: this.spaceJoincd
        }
      }
      console.log('▼▼▼▼　DEBUG:PREVIEW ESTIMATE ▼▼▼▼')
      console.log(payload)
      console.log('▲▲▲▲　DEBUG:PREVIEW ESTIMATE ▲▲▲▲')
      this.$refs.loadingModalRef.showModal(true)
      axios.post(urlStr, payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            AppUtil.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          }
          this.estimate = response.data.data
          // 掛率を％に変換
          this.convertPercent('materialMagProb')
          this.convertPercent('productMagCost')
          this.convertPercent('factoryProfit')
          this.convertPercent('profitRate1')
          this.convertPercent('profitRate2')
          this.convertPercent('profitRate3')
          this.convertPercent('profitRate4')
          console.log('▼▼▼▼　DEBUG:PREVIEW ESTIMATE DATA ▼▼▼▼')
          console.log(this.estimate)
          console.log('▲▲▲▲　DEBUG:PREVIEW ESTIMATE DATA ▲▲▲▲')
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    /** 入力値の変更 */
    changeEstimateValue: function (key, event) {
      this.$set(this.estimate, key, event.target.value)
    },
    /** プレビューで設定された見積書の値を返す */
    getPreviewEstimate: function () {
      let estimate = JSON.parse(JSON.stringify(this.estimate))
      // ％を掛率に変換
      this.convertProb(estimate, 'materialMagProb')
      this.convertProb(estimate, 'productMagCost')
      this.convertProb(estimate, 'factoryProfit')
      this.convertProb(estimate, 'profitRate1')
      this.convertProb(estimate, 'profitRate2')
      this.convertProb(estimate, 'profitRate3')
      this.convertProb(estimate, 'profitRate4')
      return estimate
    },
    /** 掛率を％に変換 */
    convertPercent: function (key) {
      let value = this.estimate[key] != null ? Math.round(this.estimate[key] * 100) : this.estimate[key]
      this.$set(this.estimate, key, value)
    },
    /** ％を掛率に変換 */
    convertProb: function (estimate, key) {
      let value = estimate[key] != null ? estimate[key] / 100 : estimate[key]
      this.$set(estimate, key, value)
    }
  },
  mounted: function () {
    this.getEstimate()
  },
  computed: {
    isOrder: function () {
      let user = AppUtil.getUserInfo()
      return user.corpId === 170
    }
  }
}
</script>
<style lang="scss" scoped>
.estimate {
  overflow: auto;
  height: 846px;
  width: 1076px;
}
p {
  margin: 0;
  font-size: 15px;
}
#tabs {
  overflow: hidden;
  display: flex;
  div {
    input {
      display: none;
    }
    label {
      display: inline-block;
      line-height: 40px;
      width: 120px;
      text-align: center;
      cursor: pointer;
      background: #eee;
      transition: 0.3s ease-in-out;
      border-radius: 10px 10px 0 0;
    }
    input:checked + label,
    label:hover {
      background: #000000;
      color: #fff;
    }
  }
}
#contents {
  width: 400px;
  height: 90px;
  padding: 10px 25px 25px 10px;
  box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.2);
  border: 1px solid #eee;
  border-top: 2px solid #000000;
  display: inline-table;
  min-height: 100%;
}
#order_contents{
  width: 700px;
  height: 90px;
  padding: 10px 25px 25px 10px;
  box-shadow: 1px 1px 1px 0 rgba(0,0,0,0.2);
  border: 1px solid #eee;
  border-top: 2px solid #000000;
  display: inline-table;
  min-height: 100%;
}
.data-area {
  li {
    padding-top: 24px;
    padding-left: 12px;
    line-height: normal;
  }
  .text-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/EstimatePreview.vue